import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const contents_confirm_location = (params: StepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'customComponent',
        name: 'ConfirmLocation',
        outputs: [],
        inputs: [],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contentsNxt:steps.contents_confirm_location.info.text',
            },
          },
        ],
      },
    ],
    nextStep: 'contents_quote',
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'maybeFetchPrices',
        inputs: [],
        outputs: [],
      },
    },
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default contents_confirm_location
